import React from 'react';
import UserManagementList from '../components/pages/userManagement/list/UserManagementList';
import Redirect from '../components/pages/redirect/Redirect';
import { Unauthorized } from '../components/pages/unauthorized/Unauthorized';
import { NotFound } from '../components/pages/notFound/NotFound';
import {
  IconBadgeAccount,
  IconBriefcase,
  IconNotepadDocument,
  IconTrash,
} from '@skf/bt-wind-rail-commonlibrary';
import UserManagementAdd from '../components/pages/userManagement/add/UserManagementAdd';
import UserManagementAssignRoles from '../components/pages/userManagement/assignRoles/UserManagementAssignRoles';
import UserManagementModify from '../components/pages/userManagement/modify/UserManagementModify';
import RoleManagementList from '../components/pages/rolesManagement/list/RoleManagementList';
import RoleManagementAdd from '../components/pages/rolesManagement/add/RoleManagementAdd';
import RoleManagementEdit from '../components/pages/rolesManagement/edit/RoleManagementEdit';
import { TurbineManagement } from '../components/pages/turbineManagement/TurbineManagement';
import { TaxonomyUpload } from '../components/pages/taxonomyUpload/TaxonomyUpload';
import { UserWebFeatures } from '../store/userSettings/types';
import SettingsPage from '../components/pages/settings/SettingsPage';
import SectionManagementList from '../components/pages/sectionManagement/SectionManagementList';
import { SectionManagementAddForm } from '../components/pages/sectionManagement/SectionManagementAdd';
import { SectionManagementEditForm } from '../components/pages/sectionManagement/SectionManagementEdit';

export enum WebSections {
  USER_MANAGEMENT = 'UserManagement',
  ROLE_MANAGEMENT = 'RoleManagement',
  TAXONOMY_UPLOAD = 'TaxonomyUpload',
  ACCOUNT_SETTINGS = 'AccountSettings',
  SECTION_MANAGEMENT = 'SectionManagement',
}

export interface IRoute {
  webSection: WebSections;
  path: string;
  component: React.FunctionComponent;
  headerIcon?: JSX.Element;
  title?: string;
  authorization?: boolean;
  role?: UserWebFeatures[];
}

export const UserManagementRoute: IRoute = {
  webSection: WebSections.USER_MANAGEMENT,
  path: '/users-management',
  component: UserManagementList,
  headerIcon: <IconBriefcase />,
  title: 'Users_Management',
};

export const UserManagementAddUsersRoute: IRoute = {
  webSection: WebSections.USER_MANAGEMENT,
  path: '/users-management/add-users',
  component: UserManagementAdd,
  title: 'Add_Users',
};

export const UserManagementAssignRolesRoute: IRoute = {
  webSection: WebSections.USER_MANAGEMENT,
  path: '/users-management/assign-roles',
  component: UserManagementAssignRoles,
  title: 'Assign_Roles',
};

export const UserManagementModifyUserRoute: IRoute = {
  webSection: WebSections.USER_MANAGEMENT,
  path: '/users-management/modify-user/:username',
  component: UserManagementModify,
  title: 'Modify_User',
};

export const RoleManagementRoute: IRoute = {
  webSection: WebSections.ROLE_MANAGEMENT,
  path: '/roles-management',
  component: RoleManagementList,
  headerIcon: <IconBadgeAccount />,
  title: 'Roles_Management',
  authorization: true,
  role: [UserWebFeatures.ROLE_MANAGEMENT_ACCESS],
};

export const RoleManagementAddRoleRoute: IRoute = {
  webSection: WebSections.ROLE_MANAGEMENT,
  path: '/roles-management/add-role',
  component: RoleManagementAdd,
  title: 'Add_Role',
};

export const RoleManagementEditRoleRoute: IRoute = {
  webSection: WebSections.ROLE_MANAGEMENT,
  path: '/roles-management/edit-role/:roleName',
  component: RoleManagementEdit,
  title: 'Edit Role',
};

export const TurbineManagementRoute: IRoute = {
  webSection: WebSections.ROLE_MANAGEMENT,
  path: '/turbine-management',
  component: TurbineManagement,
  headerIcon: <IconTrash />,
  title: 'Turbine_Management',
};

export const TaxonomyUploadRoute: IRoute = {
  webSection: WebSections.TAXONOMY_UPLOAD,
  path: '/taxonomy-upload',
  component: TaxonomyUpload,
  headerIcon: <IconNotepadDocument />,
  title: 'Upload_Taxonomy_Title',
};

export const RedirectRoute: IRoute = {
  webSection: undefined as any,
  path: '/',
  component: Redirect,
};

export const UnauthorizedRoute: IRoute = {
  webSection: undefined as any,
  path: '/unauthorized',
  component: Unauthorized,
};

export const NotFoundRoute: IRoute = {
  webSection: undefined as any,
  path: undefined as any,
  component: NotFound,
};

export const SettingsRoute: IRoute = {
  webSection: WebSections.ACCOUNT_SETTINGS,
  path: '/settings',
  component: SettingsPage,
};

export const SectionListRoute: IRoute = {
  webSection: WebSections.SECTION_MANAGEMENT,
  path: '/sections',
  component: SectionManagementList,
  headerIcon: <IconNotepadDocument />,
  title: 'Section Management',
};

export const SectionAddRoute: IRoute = {
  webSection: WebSections.SECTION_MANAGEMENT,
  path: '/sections/add',
  component: SectionManagementAddForm,
  title: 'Add Section',
};

export const SectionEditBasicPath: string = '/sections/edit';

export const SectionEditRoute: IRoute = {
  webSection: WebSections.SECTION_MANAGEMENT,
  path: `${SectionEditBasicPath}/:industry/:portalName/:webSectionDisplayName`,
  component: SectionManagementEditForm,
  title: 'Section Management',
};

//CAUTION: The order in which the routes are added is important.
export const Routes: IRoute[] = [
  UserManagementRoute,
  UserManagementAddUsersRoute,
  UserManagementAssignRolesRoute,
  UserManagementModifyUserRoute,
  RoleManagementRoute,
  RoleManagementAddRoleRoute,
  RoleManagementEditRoleRoute,
  TurbineManagementRoute,
  TaxonomyUploadRoute,
  SectionListRoute,
  SectionAddRoute,
  SectionEditRoute,
  RedirectRoute,
  UnauthorizedRoute,
  SettingsRoute,
  NotFoundRoute,
];
